import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';


import { Constant } from 'src/app/constant/constant';
import { BankService } from 'src/app/services/bank.service';
import { CommonService } from 'src/app/services/common.service';
import { DealsPaymentService } from 'src/app/services/deals-payment.service';
import { validateAllFormFields } from 'src/app/shared/utils/calsoft-validators';

@Component({
  selector: 'calsoft-add-deals-payment',
  templateUrl: './add-deals-payment.component.html',
  styleUrls: ['./add-deals-payment.component.scss']
})
export class AddDealsPaymentComponent implements OnInit, OnDestroy {


  url = '';
  sanitizedUrl = '';

  read: any = false;
  rowData: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  priceGroupList: any;
  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'id' + "," + Constant.Dsc;
  filterActive: boolean = false;
  pageIndex: any;
  pageSize: number;
  pageList: any;
  spinner: boolean;
  id: any;

  firstFormGroup: UntypedFormGroup;
  todayDate: Date = new Date();
  text: string;
  title: string;
  operationType: string;
  paginationDetail = new BehaviorSubject({
    length: 10,
    pageIndex: 0,
    pageSize: 10
  });
  pageSizeValue: any;
  search: any;
  elements: any;
  rowgap: string;
  rowLeft: string;
  rowRight: string;
  selectedIndex: any;
  public CurrenciesDetails: boolean = false;
  public CurrenciesDetails1: boolean = true;

  resourcePrivilege: any;
  data: any;
  path: string;
  remainingBalance: any=0.0;


  constructor(
    public router: Router,
    private dealsPaymentService: DealsPaymentService,
    private _formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private commonService: CommonService,
    private bankService: BankService,
    public datepipe: DatePipe,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AddDealsPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) data,

  ) {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
      this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
        this.url = this.router.url || '';
        this.sanitizedUrl = this.sanitizeUrl(this.url);
      });

    this.data = data;
    this.rowData = data['finalData'];
      this.url = this.router.url || '';
          this.router.events
            .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
            .subscribe(() => { this.url = this.router.url || ''; });

  }



  ngOnInit(): void {

    this.initDealsPaymentForm();

    this.text = 'Save';

    console.log("data" , this.data);

    const bal = (this.rowData && this.rowData.balance !== undefined && this.rowData.balance !== null)
      ? Number(this.rowData.balance)
      : ((Number(this.rowData?.amount || 0)) - (Number(this.rowData?.paid || 0)));

    this.remainingBalance = bal > 0 ? bal : 0;

    this.firstFormGroup.patchValue({
      dealsId: this.data?.dealId,
      amount: this.remainingBalance
    });

    this.firstFormGroup.controls['amount'].setValidators([
      Validators.required,
      Validators.min(0.01),
      Validators.max(this.remainingBalance)
    ]);
    this.firstFormGroup.controls['amount'].updateValueAndValidity();
  }




  editDealsPayments(dealsPayments: any) {
    this.firstFormGroup = this._formBuilder.group({
      id: dealsPayments.id,
      date: dealsPayments.date,
      saleId: dealsPayments.saleId,
      returnId: dealsPayments.returnId,
      purchaseId: dealsPayments.purchaseId,
      referenceNo: dealsPayments.referenceNo,
      transactionId: dealsPayments.transactionId,
      paidBy: dealsPayments.paidBy,
      chequeNo: dealsPayments.chequeNo,
      ccNo: dealsPayments.ccNo,
      ccHolder: dealsPayments.ccHolder,
      ccMonth: dealsPayments.ccMonth,
      ccYear: dealsPayments.ccYear,
      ccType: dealsPayments.ccType,
      amount: [dealsPayments.amount, [Validators.required, Validators.min(0.01)]],
      currency: dealsPayments.currency,
      createdBy: dealsPayments.createdBy,
      attachment: dealsPayments.attachment,
      type: dealsPayments.type,
      note: dealsPayments.note,
      posPaid: dealsPayments.posPaid,
      posBalance: dealsPayments.posBalance,
      approvalCode: dealsPayments.approvalCode,
      bankId: dealsPayments.bankId,
      visa: dealsPayments.visa,
      dealsId: dealsPayments.dealsId

    })
  }

  initDealsPaymentForm() {
    this.firstFormGroup = this._formBuilder.group({
      id: [0],
      date: new UntypedFormControl(this.datepipe.transform(this.todayDate, 'yyyy-MM-dd')),
      saleId: [''],
      returnId: [''],
      purchaseId: [''],
      referenceNo: [''],
      transactionId: [''],
      paidBy: ['1',],
      chequeNo: [''],
      ccNo: [''],
      ccHolder: [''],
      ccMonth: [''],
      ccYear: [''],
      ccType: [''],
      amount: ['', [Validators.required, Validators.min(0.01)]],
      currency: [''],
      createdBy: [''],
      attachment: [''],
      type: [''],
      note: [''],
      posPaid: [''],
      posBalance: [''],
      approvalCode: [''],
      bankId: [''],
      visa: [''],
      dealsId: [''],
    });
  }

  submit() {

    const enteredAmount = Number(this.firstFormGroup.value.amount);
    if (enteredAmount > this.remainingBalance) {
      this.snackBar.open(`Amount cannot exceed the remaining balance of ${this.remainingBalance}`, '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      this.firstFormGroup.controls['amount'].setErrors({ max: true });
      this.firstFormGroup.markAllAsTouched();
      return;
    }

    if (this.text == 'Save' && this.firstFormGroup.valid) {
      if (this.id != 0) {
        this.firstFormGroup.value.operationType = "Change"
      }
      else {
        this.firstFormGroup.value.operationType = "New"
      }
      this.text = "Processing"
      this.dealsPaymentService.addpayment(this.firstFormGroup.value).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
            this.close();
          }
          else {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { this.text = "Save" });
    }
    else {
        this.firstFormGroup.markAllAsTouched();
    }
  }

  close() {
    this.dialog.closeAll();
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

    protected _onDestroy = new Subject<void>();

    ngOnDestroy() {
        this._onDestroy.next();
        this._onDestroy.complete();
    }
}
